import type { IconSvgObject } from './types';

const Chart03Icon: IconSvgObject = [
  ["path", { d: "M3 4V18C3 19.1046 3.89543 20 5 20H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 14L11 9L14.5 12.5L20 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Chart03Icon;
